import { render, staticRenderFns } from "./NsAddressGb.vue?vue&type=template&id=74cf853c&"
import script from "./NsAddressGb.vue?vue&type=script&lang=js&"
export * from "./NsAddressGb.vue?vue&type=script&lang=js&"
import style0 from "./NsAddressGb.vue?vue&type=style&index=0&lang=scss&module=%24x&"




function injectStyles (context) {
  
  this["$x"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports